module.exports = __webpack_public_path__ + "img/рз_24.c74068c4.png";